<div class="form-container">
    <form>
        <div class="sl-item">
            <label class="item-header" style="font-family: Roboto Slab" for="username">Name</label>
            <input class="sl-input" style="font-family: Noto Sans" type="text" id="username" name="username" placeholder="Your Organization's Name" [(ngModel)]="name"><br>
        </div>
        <div class="sl-item">
            <label class="item-header" style="font-family: Roboto Slab" for="description">Description</label>
            <input class="sl-input" style="font-family: Noto Sans" type="text" id="description" name="description" placeholder="Description of Your Organization" [(ngModel)]="description"><br>
        </div>
        <div>
            <p class="item-header" style="font-family: Roboto Slab" >Categories</p>
            <ul>
                <li *ngFor="let key of interestKeys">
                    <label class="checkbox" [htmlFor]="key">
                        <input type="checkbox" [id]="key" [name]="key" [value]="key" (change)="onCheckChange($event, key)">
                        <div>
                            <span class="checkbox-text" style="font-family: Noto Sans">{{interestOptions[key]}}</span>
                            <img class="toggle-icon" src="assets/plus.svg" alt="">
                        </div>
                    </label>
                </li>
            </ul>
        </div>
        <button mat-raised-button style="font-family: Noto Sans" type="submit" value="submit" (click)="submit()">Next &rarr;</button>
    </form>
</div>